export const EventTrackerToken = Symbol('EventTracker');
export const ErrorLoggerToken = Symbol('ErrorLogger');
export const UserNotifierToken = Symbol('UserNotifier');

export const ClientManagerToken = Symbol('ClientManger');
export const CallbackFactoryToken = Symbol('CallbackFactory');
export const ObservedEventRepository = Symbol('ObservedEventRepository');
